import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import chatQuestionService from "../../../services/chatQuestionHistory/chatQuestionHistoryService";
import {
  ChatSession,
  ChatSessionDetails,
} from "../../../types/chatQuestionHistory";
interface ChatQuestionHistoryState {
  isLoading: boolean;
  isError: boolean;
  chatSession: ChatSession[];
  isEndOfData: boolean;
}
const initialState: ChatQuestionHistoryState = {
  isLoading: false,
  isError: false,
  chatSession: [],
  isEndOfData: false,
};

export const fetchChatQuestionHistory = createAsyncThunk(
  "chatQuestionHistory/fetchChatQuestionHistory",
  async (args: { page: number; limit: number }, thunkAPI) => {
    try {
      const response = await chatQuestionService.fetchChatQuestionHistory(args);
      return { data: response.data.data, params: response.params };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

const chatQuestionSlice = createSlice({
  name: "chatQuestionHistory",
  initialState,
  reducers: {
    addNewQuestionToChatSession: (
      state,
      action: PayloadAction<ChatSessionDetails>
    ) => {
      const { chat_id } = action.payload;
      const chatSession = state.chatSession.find(
        (session) => session.chat_id === chat_id
      );
      if (chatSession) {
        chatSession.chathistories.push(action.payload);
      }
    },
    addNewSession(state, action: PayloadAction<ChatSession>) {
      state.chatSession.unshift(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatQuestionHistory.pending, (state) => {
        state.isEndOfData = false;
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchChatQuestionHistory.fulfilled, (state, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.isError = false;
        if (payload.data) {
          if (payload.params.page === 1) {
            state.chatSession = payload.data;
          } else {
            state.chatSession.push(...payload.data);
          }
        } else {
          state.isEndOfData = true;
        }
      })
      .addCase(fetchChatQuestionHistory.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { addNewQuestionToChatSession, addNewSession } =
  chatQuestionSlice.actions;
export default chatQuestionSlice.reducer;
